'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventVenue = function EventVenue(_ref) {
  var room = _ref.room,
      venue = _ref.venue;

  // Assemble address lines
  var lines = [];
  if (venue.address) lines.push(venue.address);
  if (venue.address2) lines.push(venue.address2);
  if (venue.city || venue.state || venue.zip) {
    var line = [];
    if (venue.city) line.push(venue.city);
    if (venue.state) line.push('(' + venue.state + ')');
    if (venue.zip) line.push(venue.zip);
    lines.push(line.join(' '));
  }

  // Add <br/> elements between lines
  var elements = [];
  for (var i = 0; i < lines.length; i += 1) {
    elements.push(lines[i]);
    if (i < lines.length - 1) {
      elements.push(_react2.default.createElement('br', { key: i }));
    }
  }

  var latlong = venue.latitude + ',' + venue.longitude;
  var directionsURL = 'http://www.google.com/maps/place/' + latlong + '/@' + latlong + ',15z';

  return _react2.default.createElement(
    'div',
    { className: 'EventVenue' },
    venue.name && _react2.default.createElement(
      'div',
      { className: 'name' },
      venue.name
    ),
    room && room.name && _react2.default.createElement(
      'div',
      { className: 'room-name' },
      room.name
    ),
    elements.length && _react2.default.createElement(
      'address',
      null,
      elements
    ),
    venue.latitude && venue.longitude && _react2.default.createElement(
      'div',
      { className: 'directions' },
      _react2.default.createElement(
        'a',
        { target: '_blank', rel: 'noopener noreferrer', href: directionsURL },
        (0, _i18n2.default)('directions')
      )
    )
  );
};

EventVenue.propTypes = {
  /** A room as returned by the Caligram API. */
  room: _propTypes2.default.object,
  /** A venue as returned by the Caligram API. */
  venue: _propTypes2.default.object.isRequired
};

EventVenue.defaultProps = {
  room: null
};

exports.default = EventVenue;
EventVenue.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'EventVenue',
  'props': {
    'room': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'object'
      },
      'required': false,
      'description': 'A room as returned by the Caligram API.'
    },
    'venue': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': 'A venue as returned by the Caligram API.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventVenue.js
// module id = 185
// module chunks = 0